import { Button } from "@mui/material";
import React from "react";
import svg from "../../../../../assets/png/rest.png";
import svgDark from "../../../../../assets/png/rest.png";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  HOME,
  RESERVATION_ADMINISTRATION,
} from "../../../../../enums/UrlPaths";
import Loader from "../../../../../components/loader/Loader";
import FullScreenMessageCore from "../../../../../components/fullScreenMessage/FullScreenMessageCore";

export default function Resting() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [restingMan, setRestingMan] = React.useState({
    restingMan: null,
  });

  const handleNavigation = (route) => {
    navigate(route);
  };

  React.useEffect(() => {
    const loadImage = (src, key) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        setRestingMan((prevImages) => ({
          ...prevImages,
          [key]: src,
        }));
      };
    };

    loadImage(svg, "restingMan");
  }, []);

  if (restingMan.restingMan == null) {
    return <Loader condition={true} />;
  }

  function RestingManIcon() {
    return (
      <img
        src={restingMan.restingMan}
        alt="Zookeeper Letak"
        className="rest_svg"
        style={{ display: restingMan.restingMan ? "initial" : "none" }}
      />
    );
  }

  return (
    <FullScreenMessageCore
      icon={<RestingManIcon />}
      button={
        <Button
          variant="contained"
          color="secondary"
          onClick={() => handleNavigation(RESERVATION_ADMINISTRATION)}
        >
          {t("GoBackToTable")}
        </Button>
      }
      secondButton={
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => handleNavigation(HOME)}
        >
          {t("BackToHomePage")}
        </Button>
      }
      title={"NoPendingAppointments"}
      subtitle={"FeelFreeToRest"}
      testId={"appointment.pending.empty-state"}
    />
  );
}
